module.exports = __webpack_public_path__ + "static/media/YourLocalAI.fe9cf60a.png";